{
  "fr": {
    "milestone": {
      "actions": {
        "activate": "Activer",
        "active": "Actif !",
        "create": "Créer un jalon",
        "deactivate": "Désactiver",
        "delete": "Supprimer",
        "delete_milestones": "Supprimer le jalon | Supprimer {count} jalons",
        "new": "Jalon"
      },
      "attach": {
        "add": "Ajouter",
        "add_button": "Ajouter un élément",
        "add_kind": "Ajouter {kind}",
        "assigned_tag": "Attribué",
        "back": "Retour",
        "counts": "{available} disponibles · {assigned} déjà attribués",
        "description_decision": "Choix que le client doit faire",
        "description_survey": "Questionnaires pour recueillir des réponses",
        "empty": "Aucun élément disponible",
        "empty_state_description": "Selon votre formule, vous pouvez ajouter {kinds} à ce jalon.",
        "empty_state_title": "Aucun élément pour l'instant",
        "intro": "Choisissez le type d'élément que vous souhaitez lier à ce jalon.",
        "next": "Suivant",
        "search": "Rechercher",
        "select_intro": "Sélectionnez le {kind} que vous souhaitez ajouter.",
        "subtitle": "Au jalon : {name}",
        "success": "Éléments ajoutés",
        "title": "Ajouter des éléments"
      },
      "labels": {
        "add_element": "Ajouter un élément",
        "add_kind": "Ajouter {kind}",
        "assign_units": "Assigner les unités",
        "assigned_count": "0 attribué | 1 attribué | {count} attribués",
        "assigned_elements": "Éléments attribués",
        "assigned_empty_description": "Attachez des {kinds} à ce jalon",
        "assigned_empty_title": "Aucun élément pour l'instant",
        "bulk_assign_title": "Sélectionnez les unités auxquelles vous souhaitez attribuer le jalon '{milestone_name}'",
        "edit_milestone": "Editer le jalon",
        "empty_state_subtitle": "Les jalons rendent le processus de construction plus transparent pour les acheteurs de maison",
        "empty_state_title": "Créer un nouveau jalon",
        "future_milestones": "Prochains jalons",
        "kind_decision": "Décision | Décisions",
        "kind_survey": "Enquête | Enquêtes",
        "kind_todo": "Tâche | Tâches",
        "milestone": "Jalon",
        "milestone_name": "Nom du jalon",
        "milestone_unit_count": "0 unités | 1 unité | {count} unités",
        "milestones": "Jalons",
        "new_milestone": "Nouveau jalon",
        "no_milestone": "Aucun jalon n'a encore été attribué",
        "no_results": "Aucun jalon trouvé",
        "past_milestones": "Jalons passés",
        "please_select": "Veuillez sélectionner un nouveau jalon",
        "position": "Position",
        "search_empty_state": "Aucun jalon n'a encore été créé. Cliquez ici pour commencer",
        "units": "Unités",
        "units_without_milestone": "1 unité sans jalon | {count} unités sans jalon",
        "warning_delete": "Si vous supprimez un jalon qui a été attribué à une unité, le client perdra de vue à quel jalon se trouve son unité. Assurez-vous d'attribuer un nouveau jalon à ces unités!"
      },
      "toasts": {
        "bulk_assigned": "Le jalon est attribué avec succès aux unités sélectionnées",
        "create_success": "Jalon créé avec succès",
        "deactivate_success": "Le jalon a été désactivé avec succès",
        "sup_assigned": "Le jalon est activé avec succès",
        "update_success": "Les jalons ont été mis à jour avec succès"
      },
      "validation": {
        "needName": "Nom requis",
        "needNamePrimary": "Le nom dans la langue principale ({language}) est requis"
      }
    }
  }
}
